export const LOAD_STATISTICS_REQUEST = 'StatisticsPage/LOAD_STATISTICS_REQUEST';
export const LOAD_STATISTICS_SUCCESS = 'StatisticsPage/LOAD_STATISTICS_SUCCESS';
export const LOAD_STATISTICS_FAILURE = 'StatisticsPage/LOAD_STATISTICS_FAILURE';
